import React, { Component } from 'react'
import { combineLatest, Subject, BehaviorSubject, of } from 'rxjs'
import { switchMap, takeUntil, filter, map } from 'rxjs/operators'
import { flatten, includes, result, isEqual } from 'libraries/lodash'
import cx from 'classnames'
import Grid from '@material-ui/core/Grid'
import getUrl from 'front-end-core/core/url'
import { observeSelected, deselectContent } from 'front-end-core/services/StateService'
import { shorten } from 'front-end-core/services/ShortenerService'
import { isValidResponse } from 'front-end-core/helpers/dataflow'
import { PRECEDENTS_REVIEW, PRECEDENTS_ALL, PRECEDENTS_CONTENT } from 'constants/controllers'
import { requestSectionPrecedents } from 'services/PrecedentsService'
import SelectedHeader from 'components/shared/SelectedHeader'
import Icon from 'components/shared/Icon'
import ArrowLink from 'components/redesign/ArrowLink'

// TODO: Refactor into a functional component style and move away from the RX integrations

export default class PrecedentsContentHeader extends Component {
  constructor (props) {
    const State = new BehaviorSubject({})
    const Until = new Subject()
    super(...arguments)
    Object.assign(this, { State, Until })
    this.connectSource(props)
  }

  componentDidUpdate (prevProps) {
    if (!isEqual(prevProps, this.props)) {
      this.Until.next(true)
      this.connectSource(this.props)
    }
  }

  getSource ({ aol, view, sectionId }) {
    return combineLatest(
      [requestSectionPrecedents(view === 'browse' ? 'precedents' : view, sectionId, aol).pipe(filter(isValidResponse)),
        observeSelected('precedents')],
      (precedentsResponse, state) => {
        const { parents, childSections } = precedentsResponse
        // Return only parentIds that belong to this section.
        const filteredParents = Object.keys(parents).filter(id => includes(childSections, id))
        // For each parentId, filter out precedents that are not selected.
        return flatten(filteredParents.map(parentId => parents[parentId].filter(id => state[id])))
      }
    ).pipe(
      switchMap(selectedIds => selectedIds.length
        ? shorten(
          getUrl(PRECEDENTS_REVIEW, { aol, category: view, sectionId, precedentIds: selectedIds }).replace(/#/, '')
        ).pipe(map(short => ({ selectedIds, short })))
        : of({ selectedIds: [], short: null })
      )
    )
  }

  connectSource (props) {
    this.getSource(props)
      .pipe(takeUntil(this.Until))
      .subscribe(s => this.State.next(s))
  }

  renderPreviewHeader = ({ aol, view, sectionId, precedentId }) => (
    <div className='flex'>
      <ArrowLink
        backArrow
        text='Back to section list'
        url={getUrl(PRECEDENTS_CONTENT, { aol, view, sectionId, expanded: precedentId })}
      />
    </div>
  )

  renderDetailsHeader = ({ view, aol, sectionId, response = {} }) => {
    const title = result(response, ['nodes', sectionId, 'title'])

    return (
      <Grid container justify='space-between'>
        <Grid item>
          <Grid container className='f5'>
            <Grid item>
              <Grid container>
                <Grid item>
                  <Icon name='icon-precedents' className='w7' />
                </Grid>
                <Grid item>
                  <a className='black no-underline hover-underline ml4' href={getUrl(PRECEDENTS_CONTENT, { aol, view })}>
                    Precedents & Related Resources
                  </a>
                  {'\xa0 >'}
                </Grid>
                <Grid item className='precedents-blue pl4 pb4'>
                  {title}
                </Grid>
              </Grid>
            </Grid>
            <Grid item className='pl5 mt1'>
              <ViewAllLink url={getUrl(PRECEDENTS_ALL, { aol, view })} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    )
  }

  render () {
    const { sectionId, precedentId, aol, view } = this.props

    return (
      <div>
        <SelectedHeader
          {...this.props}
          stateSource={this.State}
          deselectAll={deselectContent.bind(null, 'precedents')}
          keyword={
            (l) => l === 1
              ? (view === 'browse' ? 'precedent' : 'related resource')
              : (view === 'browse' ? 'precedents' : 'related resources')
          }
          dataHelpItem='precedentstoolbar'
        />
        <div className='w-100 pt9'>
          <div className='layout-width-constraint'>
            {!sectionId && <PrecedentsTiledMenuHeader {...{ aol, view }} />}
            {sectionId && !precedentId && this.renderDetailsHeader(this.props)}
            {precedentId && this.renderPreviewHeader(this.props)}
          </div>
        </div>
      </div>
    )
  }
}

const ViewAllLink = ({ url }) => (
  <div>
    <ArrowLink
      text='View all'
      textCx='pr4'
      url={url}
    />
  </div>
)

export const PrecedentsTiledMenuHeader = ({ aol, view, isProxy = false }) => (
  <Grid container className={cx('f5', { wait: isProxy })}>
    <Grid item className='pr4'>
      <Icon name='icon-precedents' className='w7' />
    </Grid>
    <Grid item className='precedents-blue pr6'>
      Precedents & Related Resources
    </Grid>
    <Grid item className='mt1'>
      <ViewAllLink url={isProxy ? null : getUrl(PRECEDENTS_ALL, { aol, view })} />
    </Grid>
  </Grid>
)
